import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Skeleton from "react-loading-skeleton";
import { updatePaymentLocation } from "../../redux/slice/paymentLocations";
import { baseUrl } from "../../utils/apiActions/dashboardApi";
import { Link } from "react-router-dom";
import Pagination from "react-bootstrap/Pagination";
import {
  updateSearchedData,
  selectSearchedData,
} from "../../redux/slice/searchData";
import useAxios from "../../hooks/useAxios";
import { createAccount } from "../../utils/roles";
import { Button, Form, Modal } from "react-bootstrap";
const SearchAccount = () => {
  const cachedData = useSelector(selectSearchedData);
  const [searchedAccounts, setSearchedAccounts] = useState(cachedData);
  const [searchQuery, setSearchQuery] = useState();
  const [loading, setLoading] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [visiblePage, setVisiblePage] = useState(10);
  const [showNotFoundText, setShowNotFoundText] = useState(false);
  const [showCreateAccountModal, setShowCreateAccountModal] = useState(false)
  const [accountPayload, setAccountPayload] = useState({})
  const [accountTypes, setAccountTypes] = useState([])
  const [accountNumberTypes, setAccountNumberTypes] = useState([])
  const [subscriber, setSubscriber] = useState({})
  const [phoneNumber, setPhoneNumber] = useState(null)
  const [placeholderText, setPlaceholderText] = useState(
    "e.g: 0788000000, Kalisa, Mageragere, MC1692072279615615807, etc …"
  );
  const location = JSON.parse(localStorage.getItem("locations"));
  const locationId = location[location.length - 1].id;
  const roles = JSON.parse(localStorage.getItem("roles"));
  const locations = JSON.parse(localStorage.getItem("agentLocations"));
   let userLocations = [];
     locations.forEach((location) => {
       userLocations = [...userLocations, location[4]];
     });
  const dispatch = useDispatch();
  const axiosInstance = useAxios();
  const adjustSearchIcon = () =>{
    let showCreateAccount = false;
    roles?.forEach(el => {
      if (el.id === createAccount) {
        showCreateAccount = true
      }
    });
    return showCreateAccount;
  }

  const handleOnChange = (e) => {
    const { name } = e.target
    const { value } = e.target
    setAccountPayload({
      ...accountPayload,
      [name]: value,
    });
  }


  const searchAccountData = async () => {
    setSearchedAccounts([]);
    setLoading(true);

    const encodedQuery = searchQuery.replace(/\s+/g, "+");
    const url = `${baseUrl}/search?query=${encodedQuery}&locationId=${locationId}`;
    try {
      const res = await axiosInstance.get(url);
      if (res.status >= 200 && res.status <= 300) {
        if (res.data.length === 0) {
          setShowNotFoundText(true);
        }
        setSearchedAccounts(res.data);
        setLoading(false);
        dispatch(updateSearchedData(res.data));
      }
    } catch (error) {
      console.error(error);
    }
  };
  const onClickHandler = async (account) => {
    const { locationId } = account;
    try {
      const res = await axiosInstance.get(`/locations/${locationId}/details`);
      dispatch(updatePaymentLocation(res.data));
    } catch (error) {
      console.error(error);
    }
  };
  const fetchTypes = async () => {
    const res = await axiosInstance.get(`/accounts/types`);
    setAccountTypes(res.data)
  }
  const fetchNumberTypes = async () => {
    const res = await axiosInstance.get(`/accounts/numberTypes`);
    setAccountNumberTypes(res.data)
  };
  const fetchSubscriber = async () => {
    let res = await axiosInstance.get(
      `/subscribers?phoneNumber=25${phoneNumber}`
    );
    if (res.data?.id == 0) {
      const payload = {
        phoneNumber: `25${phoneNumber}`,
        languageId: 1,
      };
      res = await axiosInstance.post(`/subscribers/languages`, payload);
    }
    setSubscriber(res.data)
  };
  useEffect(() => {
    fetchTypes();
    fetchNumberTypes();
  },[])
  useEffect(() => {
    if (window.innerWidth <= 768) {
      setPlaceholderText("e.g: 0788000000, Kalisa, Mageragere,etc ...");
      setVisiblePage(3);
    } else {
      setPlaceholderText(
        "e.g: 0788000000, Kalisa, Mageragere, MC1692072279615615807, etc …"
      );
      setVisiblePage(10);
    }
  }, []);
  function splitText(text) {
    const parts = text.split(", ");
    const first = parts.shift();
    const rest = parts.join(", ");
    return { first, rest };
  }
  const itemsPerPage = 100;
  const totalPages = Math.ceil(searchedAccounts?.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
  };
  const submitAccount = async(e) => {
    e.preventDefault();
    const payload = {
      ...accountPayload,
      subscriberId: subscriber?.id,
      statusId: 1,
      accountNumber:
        accountPayload.numberTypeId == 1
          ? `25${accountPayload.accountNumber}`
          : accountPayload.accountNumber,
    };
    try {
      const res = await axiosInstance.post("/accounts", payload);
      if (res.status >= 200 && res.status <= 300) setShowCreateAccountModal(false);
  } catch (error) {
    console.error('Error during creating account:', error);
  }
    
  }

  const startIndex = (activePage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const itemsToDisplay = searchedAccounts?.slice(startIndex, endIndex);

  const paginationItems = [];

  if (totalPages <= 10) {
    for (let i = 1; i <= totalPages; i++) {
      paginationItems.push(
        <Pagination.Item
          key={i}
          active={i === activePage}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </Pagination.Item>
      );
    }
  } else {
    const maxVisiblePages = visiblePage;

    // Calculate the range of visible pages
    let startPage = Math.max(activePage - Math.floor(maxVisiblePages / 2), 1);
    let endPage = startPage + maxVisiblePages - 1;

    // Ensure that the endPage does not exceed totalPages
    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(endPage - maxVisiblePages + 1, 1);
    }

    // Add Pagination.First
    paginationItems.push(
      <Pagination.First
        key='pagination-first'
        onClick={() => handlePageChange(1)}
        disabled={activePage === 1}
      />
    );

    // Add ellipsis if not on the first page
    if (startPage > 2) {
      paginationItems.push(<Pagination.Ellipsis key='ellipsis-start' />);
    }

    // Add visible page numbers
    for (let i = startPage; i <= endPage; i++) {
      paginationItems.push(
        <Pagination.Item
          key={i}
          active={i === activePage}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </Pagination.Item>
      );
    }

    // Add ellipsis if not on the last page
    if (endPage < totalPages - 1) {
      paginationItems.push(<Pagination.Ellipsis key='ellipsis-end' />);
    }

    // Add Pagination.Last
    paginationItems.push(
      <Pagination.Last
        key='pagination-last'
        onClick={() => handlePageChange(totalPages)}
        disabled={activePage === totalPages}
      />
    );
  }
  return (
    <div>
      <div className='d-flex justify-content-center mt-3 font-family'>
        <h4 style={{ fontSize: 40 }}>Find Account</h4>
      </div>
      <div>
        <div className='d-flex justify-content-center'>
          <p
            className='ml-3 font-family'
            style={{ fontWeight: 700, fontSize: 18 }}
          >
            Find account by phone number, names, location, account id, house id,
            <br />
            <p className='ml-5 font-family' style={{ fontSize: 18 }}>
              transaction id, creation date, time, id, etc…
            </p>
          </p>
        </div>
        <div className={`search-container pb-3`}>
          <input
            type='text'
            className='search-bar'
            placeholder={placeholderText}
            onChange={(e) => {
              setSearchQuery(e.target.value);
              setShowNotFoundText(false);
            }}
            onKeyPress={(e) => {
              if (
                e.key === "Enter" &&
                searchQuery !== undefined &&
                searchQuery !== ""
              )
                searchAccountData();
            }}
          />
          <i
            className='material-icons search-icon'
            style={{
              color: "#0101ff",
              cursor: "pointer",
              top: roles.some((role) =>
                role.id == createAccount ? "33%" : ""
              ),
              cursor: "pointer",
              top: adjustSearchIcon() ? "33%" : "",
              right: adjustSearchIcon() ? "33%" : "",
            }}
            onClick={() => {
              if (searchQuery !== undefined && searchQuery !== "")
                searchAccountData();
            }}
          >
            search
          </i>
          {roles?.some((role) => role.id === createAccount) && (
            <Button
              className='custom-btn-color ml-5 mb-3'
              type='submit'
              onClick={() => setShowCreateAccountModal(true)}
            >
              Konti Nshya
            </Button>
           )}
        </div>
      </div>
      <div className='d-flex justify-content-center'>
        {showNotFoundText && <h4 className='ml-3'>No Account Found</h4>}
      </div>
      {searchedAccounts?.length > 0 && (
        <div className='d-flex justify-content-center'>
          <h4 className='mt-3 mb-3'>
            {searchedAccounts?.length > 0 &&
              `${searchedAccounts?.length} Account${
                searchedAccounts?.length > 1 ? "s" : ""
              } Found`}
          </h4>
        </div>
      )}

      {searchedAccounts?.length > 0 &&
        itemsToDisplay?.map((account, index) => (
          <div className='mt-3 mb-5 search-content' key={index}>
            <Link
              to={`/loggedin/account/${splitText(account.header).first}`}
              onClick={() => onClickHandler(account)}
            >
              <h4 className='account-link' style={{ color: "#0066ff" }}>
                <span style={{ color: "#ed7d31" }}>
                  {splitText(account.header).first}
                  ,&nbsp;
                </span>
                {splitText(account.header).rest}
              </h4>
            </Link>
            <h5 style={{ wordWrap: "break-word", overflowWrap: "break-word" }}>
              {account?.data[0]}
            </h5>
            <h5 className='mt-3'>{account?.data[1]}</h5>
          </div>
        ))}
      {loading && (
        <>
          <div className='search-content'>
            <div className='mt-5'>
              <Skeleton width={650} height={20} />
              <Skeleton width={350} height={20} />
            </div>
          </div>
          <div className='search-content'>
            <div className='mt-4'>
              <Skeleton width={650} height={20} />
              <Skeleton width={350} height={20} />
            </div>
          </div>
          <div className='search-content'>
            <div className='mt-4'>
              <Skeleton width={650} height={20} />
              <Skeleton width={350} height={20} />
            </div>
          </div>
        </>
      )}
      {searchedAccounts?.length > 100 && (
        <div className='pagination-items'>
          <Pagination>
            <Pagination.Prev
              onClick={() => handlePageChange(activePage - 1)}
              disabled={activePage === 1}
            />
            {paginationItems}
            <Pagination.Next
              onClick={() => handlePageChange(activePage + 1)}
              disabled={activePage === totalPages}
            />
          </Pagination>
        </div>
      )}
      <Modal
        aria-labelledby='contained-modal-title-vcenter'
        centered
        show={showCreateAccountModal}
      >
        <Modal.Header
          closeButton
          onClick={() => setShowCreateAccountModal(false)}
        >
          <Modal.Title>Create account</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={submitAccount}>
            <label className='ml-2 mt-2'>Amazina</label>
            <input
              type='text'
              className='form-control'
              placeholder='Amazina ya nyiri konti'
              name='accountName'
              onChange={handleOnChange}
              required
            />
            <label className='ml-2 mt-2'>Tel</label>
            <input
              type='number'
              className='form-control'
              placeholder='078xxxxxxx/079xxxxxxx'
              name='phoneNumber'
              onChange={(e) => setPhoneNumber(e.target.value)}
              required
            />
            <label className='ml-2 mt-2'>Hitamo umudugudu</label>
            <select
              className='form-control'
              name='locationId'
              onChange={handleOnChange}
              required
            >
              <option value=''>Hitamo umudugudu</option>
              {userLocations?.map((location) => (
                <option value={location?.id}>{location?.name}</option>
              ))}
            </select>
            <label className='ml-2 mt-2'>Ubwoko bw'inzu</label>
            <select
              className='form-control'
              name='typeId'
              onChange={(e) => {
                handleOnChange(e);
                fetchSubscriber();
              }}
              required
            >
              <option value=''>Hitamo ubwoko bw'inzu</option>
              {accountTypes?.map((type) => (
                <option value={type.id}>{type.name}</option>
              ))}
            </select>
            <label className='ml-2 mt-2'>Ubwoko bwa Konti</label>
            <select
              className='form-control'
              name='numberTypeId'
              onChange={handleOnChange}
              required
            >
              <option value=''>Hitamo ubwoko bwa konti</option>
              {accountNumberTypes?.map((type) => {
                if (type.id == 5) return null
                return <option value={type.id}>{type.name}</option>;
              })}
            </select>
            <label className='ml-2 mt-2'>Phone/NID/TIN</label>
            <input
              type='number'
              className='form-control'
              placeholder='Phone/NID/TIN'
              name='accountNumber'
              onChange={handleOnChange}
              required
            />
            <label className='ml-2 mt-2'>Ibirarane</label>
            <input
              type='number'
              className='form-control'
              placeholder='Shyiramo ibirarane'
              name='outstandingAmount'
              onChange={handleOnChange}
              required
            />
            <label className='ml-2 mt-2'>Ayishyurwa</label>
            <input
              type='number'
              className='form-control'
              placeholder='Ayishyurwa ku kwezi'
              name='monthlyFee'
              onChange={handleOnChange}
              required
            />
            <div className='d-flex justify-content-center'>
              <Button className='custom-btn-color' type='submit'>
                Submit
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SearchAccount;
